export function buildWebClientContext({
  currentScreen = null,
  reproSteps = null,
  crashFlag = false,
} = {}) {
  const nav = typeof navigator !== 'undefined' ? navigator : null;
  const ua = nav?.userAgent || '';
  const platform = /iphone|ipad|ipod/i.test(ua)
    ? 'ios'
    : /android/i.test(ua)
      ? 'android'
      : 'web';

  return {
    appVersion: process.env.REACT_APP_VERSION || 'web',
    buildNumber: process.env.REACT_APP_BUILD || 'web',
    platform,
    osVersion: nav?.platform || null,
    deviceModel: nav?.userAgent || null,
    locale: nav?.language || null,
    networkState: nav?.onLine === false ? 'offline' : 'online',
    currentScreen,
    reproSteps,
    crashFlag: Boolean(crashFlag),
  };
}
